export default __webpack_public_path__ + "static/lo-fly-dirt-gui-2ed09431439a6995b1b28cd60b85aca6.png";